import { CaseAssignmentOverview } from '@interhyp/module-case-assignment';
import { BaseLayout, Footer } from '@interhyp/platform-layout';
import React from 'react';

function CaseAssignmentOverviewModule() {
  return (
    <>
      <BaseLayout>
        <CaseAssignmentOverview />
      </BaseLayout>
      <Footer />
    </>
  );
}

export { CaseAssignmentOverviewModule };
